import{LanguageControl as a}from"@edikk-edikk/shared";import{DI_CONTAINER_TYPE as e}from"../objects/index.js";const i=(o,n,t)=>{o.bind(e.languageControl).toDynamicValue(()=>new a(n,t)).inSingletonScope()};export{i as initLanguageControl};
